import { render, staticRenderFns } from "./sendCardSamplePop.vue?vue&type=template&id=c5ef65a8"
import script from "./sendCardSamplePop.vue?vue&type=script&lang=js"
export * from "./sendCardSamplePop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c5ef65a8')) {
      api.createRecord('c5ef65a8', component.options)
    } else {
      api.reload('c5ef65a8', component.options)
    }
    module.hot.accept("./sendCardSamplePop.vue?vue&type=template&id=c5ef65a8", function () {
      api.rerender('c5ef65a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/common/popup/sendCardSamplePop.vue"
export default component.exports